import { callProcedure } from 'clickNgo/helpers/api'

import { IMarketYoyGrowthPlanningApi } from './types'

/**
 * Persists the planning header (e.g. a Draft → Published transition). The SP
 * response shape is unconfirmed, so success is treated as opaque — callers
 * fold the new status client-side.
 */
export const applyYoyGrowthPlanningChanges = async (
  payload: IMarketYoyGrowthPlanningApi
): Promise<void> => {
  const response = await callProcedure({
    url: '/webservice/621/sp/v4/spJBPYoYGrowthPlanningApplyChanges/call',
    method: 'POST',
    data: {
      'p.DataJSON': JSON.stringify(payload),
    },
  })

  if ('error' in response) {
    throw response.error
  }
}
